// 曲线图

import React, { useMemo } from 'react';
import EChartsReact from "../../../Common/Utils/EChartsReact";

const LineChartView = ({
    x_label = '',
    y1_label = '',
    y2_label = '',
    x_data = [],
    y1_data = [],
    y2_data = []
}) => {
    // ✅ 使用 useMemo 缓存 option，只有当数据真正变化时才重新计算
    const chartOption = useMemo(() => {
        // 防御性检查：确保数据是数组
        const validXData = Array.isArray(x_data) ? x_data : [];
        const validY1Data = Array.isArray(y1_data) ? y1_data : [];
        const validY2Data = Array.isArray(y2_data) ? y2_data : [];

        // 生成带时间戳的默认文件名，格式：相关性分析_YYMMDD
        const defaultFileName = `相关性分析_${new Date().toISOString().slice(2, 8).replace(/-/g, '')}`; // e.g., "相关性分析_250917"

        return {
            tooltip: {
                trigger: 'axis',
                formatter: (params) => {
                    if (!params || !params.length) return '';
                    let res = `<strong>${params[0].name}</strong><br/>`;
                    params.forEach(param => {
                        res += `${param.seriesName}: ${param.value}<br/>`;
                    });
                    return res;
                }
            },
            legend: {
                top: 'top',
                data: [y1_label, y2_label]
            },
            toolbox: {
                show: true,
                feature: {
                    dataZoom: {
                        yAxisIndex: 'none',
                        title: {
                            zoom: '区域缩放',
                            back: '区域缩放还原'
                        }
                    },
                    dataView: {
                        readOnly: false,
                        title: '数据视图',
                        lang: ['数据视图', '关闭', '刷新']
                    },
                    restore: {
                        title: '重置'
                    },
                    saveAsImage: {
                        title: '保存为图片',
                        name: defaultFileName, // ✅ 3️⃣ 自定义文件名
                        type: 'png', // 可选 png / jpg / svg
                        backgroundColor: '#fff' // 白底
                    }
                }
            },
            // ✅ 1️⃣ 在底部添加 DataZoom 滑块
            dataZoom: [
                {
                    type: 'slider',
                    show: true,
                    // zoomLock: false,
                    start: 0,
                    end: 100
                }
            ],
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: validXData, // ✅ 使用传入的 x_data
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#ccc',   // 轴线颜色
                        width: 1
                    }
                },
                splitLine: {
                    show: true,       // ✅ 开启网格线（垂直线）
                    lineStyle: {
                        type: 'solid',  // 实线
                        color: '#e0e0e0', // 浅灰色
                        width: 1
                    }
                },
                axisTick: {
                    show: true,       // ✅ 显示刻度小线（可选，增强视觉）
                    alignWithLabel: true,
                    length: 6,        // 刻度长度（向上延伸）
                    lineStyle: {
                        color: '#999',  // 刻度线颜色
                        width: 1
                    }
                },
                axisLabel: {
                    rotate: 0,
                    fontSize: 12,
                    margin: 10,
                    color: '#333'
                }
            },
            yAxis: {
                type: 'value',
                axisLabel: {
                    formatter: '{value}'
                }
            },
            series: [
                {
                    name: y1_label || '曲线1',
                    type: 'line',
                    data: validY1Data, // ✅ 使用传入的 y1_data
                    // smooth: 0.5,
                    itemStyle: { color: '#5470C6' },
                    symbolSize: 6,
                    markPoint: {
                        data: [
                            { type: 'max', name: 'Max' },
                            { type: 'min', name: 'Min' }
                        ]
                    },
                    markLine: {
                        data: [{ type: 'average', name: 'Avg' }]
                    }
                },
                {
                    name: y2_label || '曲线2',
                    type: 'line',
                    data: validY2Data, // ✅ 使用传入的 y2_data
                    // smooth: 0.8,
                    itemStyle: { color: '#91CC75' },
                    symbolSize: 6,
                    markPoint: {
                        data: [
                            { type: 'max', name: 'Max' },
                            { type: 'min', name: 'Min' }
                        ]
                    },
                    markLine: {
                        data: [{ type: 'average', name: 'Avg' }]
                    }
                }
            ],
            grid: {
                left: '5%',
                right: '5%',
                bottom: '15%',
                top: '15%',
                containLabel: true
            },
            textStyle: {
                fontFamily: 'Microsoft YaHei, sans-serif'
            }
        };
    }, [y1_label, y2_label, x_data, y1_data, y2_data]); // ✅ 依赖项稳定，不会重复创建

    // ✅ 不需要 useEffect 和 setChartOption！直接用 useMemo 返回值
    return (
        <div style={{ height: 500, width: '100%', marginTop: 40 }}>
            <EChartsReact option={chartOption} loading={!x_data?.length} />
        </div>
    );
};

export default LineChartView;